import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product } from 'src/app/models/core/product.model';
import { getProductIcon } from 'src/app/types/product-type-icon.map';
import { getSellerSoldCount, getSoldShare } from 'src/app/utils/sold-share';
import { ShareRowVm } from './share-row.types';

const SINGLE_SALE = 1;

/**
 * Fila de Productos vendidos (opción C): cuánto vendió el vendedor de un producto
 * y qué parte del total del tab representa, con la barra de progreso.
 * Tocarla lleva a los tickets vendidos de ese producto.
 *
 * Con `row` en vez de `product` pinta datos ya resueltos (rankings del jefe y del
 * administrador); `expanded` la vuelve el encabezado de un desplegable.
 */
@Component({
  selector: 'app-sold-product-share-row',
  templateUrl: './sold-product-share-row.component.html',
  styleUrls: ['./sold-product-share-row.component.scss'],
  standalone: false,
})
export class SoldProductShareRowComponent {
  @Input() product?: Product;
  /** Ventas totales del tab: el denominador del porcentaje (solo con `product`). */
  @Input() totalSold = 0;
  @Input() row?: ShareRowVm;
  /** false mientras hay búsqueda: el total son solo las filas filtradas y el % sería falso. */
  @Input() showShare = true;
  /** false: la fila no hace nada al tocarla, así que no es un botón. */
  @Input() interactive = true;
  /** null: no es desplegable. true/false: estado del panel que controla. */
  @Input() expanded: boolean | null = null;
  /** id del panel que abre la fila (aria-controls). */
  @Input() controlsId: string | null = null;
  @Output() pressed = new EventEmitter<number | string>();

  get id(): number | string | undefined {
    return this.row?.id ?? this.product?.id;
  }

  get icon(): string {
    return getProductIcon(this.product?.product_type);
  }

  get sold(): number {
    return this.product ? getSellerSoldCount(this.product) : 0;
  }

  get share(): number | null {
    if (!this.showShare) return null;
    if (this.row) return this.row.share;
    return getSoldShare(this.sold, this.totalSold);
  }

  get soldLabelKey(): string {
    return this.sold === SINGLE_SALE ? 'products.sold-count-one' : 'products.sold-count';
  }

  onPress(): void {
    const id = this.id;
    if (id !== undefined) this.pressed.emit(id);
  }
}
